import { createFileRoute, redirect } from '@tanstack/react-router';

// FSU shell unification: /admin/finance/settings (no sub-segment) defaults
// to the Setup sub-tab so a user clicking the Settings primary-nav entry
// lands on a non-empty page.
export const Route = createFileRoute('/admin/finance/settings/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/finance/settings/setup' });
  },
});
